import { CclInfoTableRowTemplate } from "../../../../components/common/cclInfoTable/cclInfoTable";
import { eInfoTableValueFieldEditType } from "../../../../components/common/cclInfoTable/cclInfoTableValueField";

export const CclInfoTblManagmentInfoTemplate: CclInfoTableRowTemplate[] = [
    {
        id: "prrKey",
        fieldType: "string",
        editable: true,
        label: "Region",
        required: false,
        value: "",
        actionField: null,
        valueField: {
            value: "",
            editFieldType: eInfoTableValueFieldEditType.Select,
            url: null,
            hoverText: null,
            checked: null,
            id: "profile-reporting-region",
            selectOptions: null, //TODO: Fix this for drop down option
        },
    },
    {
        id: "prlKey",
        fieldType: "string",
        editable: true,
        label: "Reporting Location",
        required: false,
        value: "",
        actionField: null,
        valueField: {
            value: "",
            editFieldType: eInfoTableValueFieldEditType.Select,
            url: null,
            hoverText: null,
            checked: null,
            id: "profile-reporting-location",
            selectOptions: null, //TODO: Fix this for drop down option
        },
    },
    {
        id: "pfsKey",
        fieldType: "string",
        editable: true,
        label: "Fee Structure",
        required: false,
        value: "",
        actionField: null,
        valueField: {
            value: "",
            editFieldType: eInfoTableValueFieldEditType.Select,
            url: null,
            hoverText: null,
            checked: null,
            id: "profile-fee-structure",
            selectOptions: null, //TODO: Fix this for drop down option
        },
    },
    {
        id: "cclstartDate",
        fieldType: "Date",
        editable: true,
        label: "CCL Start Date",
        required: false,
        value: "",
        actionField: null,
        valueField: {
            value: "",
            editFieldType: eInfoTableValueFieldEditType.DatePicker,
            url: null,
            hoverText: null,
            checked: null,
            id: "",
            selectOptions: null, //TODO: Fix this for drop down option
        },
    },
];
